export default "__VITE_ASSET__VHhTdzpRCdYGFNlbkDpmmA__"